function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { getChinaLocalization } from 'shared/account/reducer';
import featureEnabled from 'shared/helper/feature';
import Link from 'shared/components/Link';
import { T, useTranslate } from 'shared/helper/translate';
import { getTotalEditsForTrialBanner } from 'researcher/digital-editing/reducer';
import { price } from 'researcher/helpers/price';
import ConfirmActivationModal from 'rubriq/plan/ConfirmActivationModal';
import { startSubscriptionImmediately } from 'rubriq/actions';
import { trackUpgradeClick } from 'rubriq/helpers/navbarTracking';
import { getEditingStatus } from '../reducer';
import './trial-usage-banner.scss';

// Session-scoped dismiss — resets every browser session (tab-scoped).
var DISMISS_KEY = 'trial_usage_banner_dismissed_at_count';

// Thresholds for switching from blue → yellow.
var ROW_YELLOW_THRESHOLD = 2;
var CHINA_YELLOW_THRESHOLD = 4;

/**
 * TrialUsageBanner
 *
 * Both the "upgrade your plan" (blue) and "Subscribe" (yellow) links perform the
 * SAME action as the navbar UPGRADE button:
 *   - rubriq_cardless_free_trial ON  → navigate to /rubriq/plan/subscribe
 *   - rubriq_cardless_free_trial OFF → replicate navbar handleUpgradeClick:
 *       • China cart / rubriq_activation_modal → navigate /rubriq/plan/subscribe
 *       • otherwise → open ConfirmActivationModal (startSubscriptionImmediately)
 */
var TrialUsageBanner = function TrialUsageBanner(_ref) {
  var _plan$paddleSubscript;
  var documentCount = _ref.documentCount;
  var _useState = useState(function () {
      var stored = sessionStorage.getItem(DISMISS_KEY);
      return stored !== null ? parseInt(stored, 10) : null;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    dismissedAtCount = _useState2[0],
    setDismissedAtCount = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showActivationModal = _useState4[0],
    setShowActivationModal = _useState4[1];
  var dismissed = dismissedAtCount !== null && documentCount <= dismissedAtCount;
  var dispatch = useDispatch();
  var navigate = useNavigate();
  var isChinaUser = useSelector(getChinaLocalization);
  var paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');
  var useCartInsteadOfPaddle = isChinaUser && !paddleBillingForChina;
  var cardlessTrialEnabled = featureEnabled('rubriq_cardless_free_trial');
  var skipActivationModal = featureEnabled('rubriq_activation_modal');
  var _useSelector = useSelector(getEditingStatus),
    hasActiveTrial = _useSelector.hasActiveTrial,
    trialDaysRemaining = _useSelector.trialDaysRemaining;
  var totalEdits = useSelector(getTotalEditsForTrialBanner);

  // These selectors are only needed for the ConfirmActivationModal flow.
  // They are safe to call unconditionally (useSelector hooks must not be conditional).
  var plan = useSelector(function (_ref2) {
    var curie = _ref2.curie;
    return curie === null || curie === void 0 ? void 0 : curie.plan;
  });
  var transactionPreview = useSelector(function (_ref3) {
    var curie = _ref3.curie;
    return curie === null || curie === void 0 ? void 0 : curie.transactionPreview;
  });
  var user = useSelector(function (state) {
    return state === null || state === void 0 ? void 0 : state.user;
  });
  var subscriptionId = plan === null || plan === void 0 || (_plan$paddleSubscript = plan.paddleSubscription) === null || _plan$paddleSubscript === void 0 ? void 0 : _plan$paddleSubscript.paddleId;

  // Nothing to show if: not an active trial, no docs processed, or dismissed this session.
  if (!hasActiveTrial || documentCount < 1 || dismissed) {
    return null;
  }
  var opensActivationModal = !cardlessTrialEnabled && !useCartInsteadOfPaddle && !skipActivationModal;
  var upgradeHref = opensActivationModal ? undefined : '/rubriq/plan/subscribe';
  var daysLeft = trialDaysRemaining !== null && trialDaysRemaining !== void 0 ? trialDaysRemaining : 0;
  var yellowThreshold = isChinaUser ? CHINA_YELLOW_THRESHOLD : ROW_YELLOW_THRESHOLD;
  var isYellow = daysLeft <= yellowThreshold;
  var endsTodayOrTomorrow = daysLeft <= 0 ? 'today' : 'tomorrow';
  var handleDismiss = function handleDismiss() {
    sessionStorage.setItem(DISMISS_KEY, String(documentCount));
    setDismissedAtCount(documentCount);
  };
  var handleUpgradeClick = function handleUpgradeClick(event) {
    if (upgradeHref && event && (event.defaultPrevented || event.button === 1 || event.metaKey || event.ctrlKey)) {
      return;
    }
    if (event) {
      event.preventDefault();
    }
    if (!isChinaUser) {
      trackUpgradeClick();
    }
    if (!opensActivationModal) {
      navigate('/rubriq/plan/subscribe');
      return;
    }
    setShowActivationModal(true);
  };
  var handleConfirmActivation = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (subscriptionId) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.next = 4;
            return dispatch(startSubscriptionImmediately(subscriptionId));
          case 4:
            setShowActivationModal(false);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleConfirmActivation() {
      return _ref4.apply(this, arguments);
    };
  }();
  var getModalAmount = function getModalAmount() {
    if (!(user !== null && user !== void 0 && user.currency) || (plan === null || plan === void 0 ? void 0 : plan.planPrice) == null) {
      return '';
    }
    if (isChinaUser) {
      return price(user.currency, plan.planPrice, true, true);
    }
    if (transactionPreview !== null && transactionPreview !== void 0 && transactionPreview.formattedTotal) {
      return transactionPreview.formattedTotal;
    }
    return price(user.currency, plan.planPrice, true, true);
  };
  var getModalRenewDate = function getModalRenewDate() {
    var interval = plan === null || plan === void 0 ? void 0 : plan.subscriptionInterval;
    return moment().add(1, interval === 'monthly' ? 'month' : 'year').format('DD MMM YYYY');
  };

  // --- Render ---
  var alertClass = isYellow ? 'alert-warning' : 'alert-info';
  var bannerStyle = isYellow ? {
    backgroundColor: '#fffbeb',
    borderColor: '#fde68a'
  } : {
    backgroundColor: '#eff8ff',
    borderColor: '#bfdbfe'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "row mb-3"
  }, opensActivationModal && /*#__PURE__*/React.createElement(ConfirmActivationModal, {
    open: showActivationModal,
    amount: getModalAmount(),
    renewDate: getModalRenewDate(),
    onConfirm: handleConfirmActivation,
    onClose: function onClose() {
      return setShowActivationModal(false);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-block ".concat(alertClass, " d-flex align-items-start justify-content-between gap-3 mb-0"),
    style: bannerStyle,
    role: "alert",
    "aria-live": "polite"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start gap-2 flex-grow-1"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: isYellow ? 'fa-light fa-triangle-exclamation' : 'fa-light fa-circle-info',
    className: "mt-1 flex-shrink-0",
    style: {
      color: isYellow ? '#ea580c' : '#2563eb'
    },
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    style: isYellow ? {
      color: '#000'
    } : undefined
  }, isYellow ? /*#__PURE__*/React.createElement(YellowBannerCopy, {
    isChinaUser: isChinaUser,
    documentCount: documentCount,
    totalEdits: totalEdits,
    endsTodayOrTomorrow: endsTodayOrTomorrow,
    upgradeHref: upgradeHref,
    onUpgradeClick: handleUpgradeClick
  }) : /*#__PURE__*/React.createElement(BlueBannerCopy, {
    documentCount: documentCount,
    totalEdits: totalEdits,
    upgradeHref: upgradeHref,
    onUpgradeClick: handleUpgradeClick
  }))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "flex-shrink-0 border-0 bg-transparent p-0 lh-1",
    style: {
      fontSize: '1.25rem',
      color: 'inherit',
      opacity: 0.6,
      cursor: 'pointer'
    },
    "aria-label": "Dismiss banner",
    onClick: handleDismiss
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")))));
};

// Renders the markdown link as the upgrade control.
// Navigation path (href present): a real <a> with the embedded URL.
// Modal path (no href): a button — no URL, click opens ConfirmActivationModal.
var upgradeLinkRenderer = function upgradeLinkRenderer(href, onUpgradeClick, className) {
  return function (_ref5) {
    var children = _ref5.children;
    var linkClassName = "fw-semibold text-decoration-underline ".concat(className);
    if (href) {
      return /*#__PURE__*/React.createElement("a", {
        href: href,
        className: linkClassName,
        onClick: onUpgradeClick
      }, children);
    }
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "btn btn-link p-0 align-baseline border-0 ".concat(linkClassName),
      onClick: onUpgradeClick
    }, children);
  };
};
var BlueBannerCopy = function BlueBannerCopy(_ref6) {
  var documentCount = _ref6.documentCount,
    totalEdits = _ref6.totalEdits,
    upgradeHref = _ref6.upgradeHref,
    onUpgradeClick = _ref6.onUpgradeClick;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var documents = t(documentCount === 1 ? 'trial-banner-document' : 'trial-banner-documents', {
    count: documentCount
  });
  var changes = t(totalEdits === 1 ? 'trial-banner-change' : 'trial-banner-changes', {
    count: totalEdits
  });
  return /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "trial-banner-blue-copy",
    params: {
      documents: documents,
      changes: changes,
      upgradeRoute: upgradeHref || '#'
    },
    linkRenderer: upgradeLinkRenderer(upgradeHref, onUpgradeClick, 'trial-banner-link--green')
  });
};
var YellowBannerCopy = function YellowBannerCopy(_ref7) {
  var isChinaUser = _ref7.isChinaUser,
    documentCount = _ref7.documentCount,
    totalEdits = _ref7.totalEdits,
    endsTodayOrTomorrow = _ref7.endsTodayOrTomorrow,
    upgradeHref = _ref7.upgradeHref,
    onUpgradeClick = _ref7.onUpgradeClick;
  var _useTranslate2 = useTranslate(),
    t = _useTranslate2.t;
  var documents = t(documentCount === 1 ? 'trial-banner-document' : 'trial-banner-documents', {
    count: documentCount
  });
  var changes = t(totalEdits === 1 ? 'trial-banner-change' : 'trial-banner-changes', {
    count: totalEdits
  });
  var trialEnds = isChinaUser ? t('trial-banner-ends-soon') : t("trial-banner-ends-".concat(endsTodayOrTomorrow));
  return /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "trial-banner-yellow-copy",
    params: {
      documents: documents,
      changes: changes,
      trialEnds: trialEnds,
      upgradeRoute: upgradeHref || '#'
    },
    linkRenderer: upgradeLinkRenderer(upgradeHref, onUpgradeClick, 'trial-banner-link--orange')
  });
};
export default TrialUsageBanner;